import { createPinia } from 'pinia';
import type { App } from 'vue';

export default async (app: App) => {
  app.use(createPinia())
  return;
}
